import usePrivateAxios from '@/common/api/usePrivateAxios'
import { DisablePriceSurveyValidationSchema } from '@/features/privateCompanies/schemas/disablePriceSurvey.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

interface UseDisablePriceSurveyProps {
  priceSurveyId?: string
  onSuccess?: () => void
  onError?: (error: AxiosError) => void
}

export const useDisableClientPriceSurvey = ({ priceSurveyId, onSuccess, onError }: UseDisablePriceSurveyProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation<void, AxiosError, DisablePriceSurveyValidationSchema>({
    mutationKey: ['disablePriceSurvey', priceSurveyId],
    mutationFn: async (data) => {
      await privateAxios.put(`/client/price_surveys/${priceSurveyId}/disable`, {
        price_survey: data,
      })
    },
    onSuccess,
    onError,
  })
}
